import styled from 'styled-components';

import { Button } from '@xing-com/crate-lebenslauf-button';
import { IllustrationSpotJobPosition } from '@xing-com/illustrations';
import { Label } from '@xing-com/label';
import { Tag } from '@xing-com/tag';
import {
  spaceM,
  spaceL,
  spaceXXL,
  xdlColorBorderSoft,
  xdlColorTextSecondary,
} from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

export const StyledSubmitButton = styled(Button)`
  margin-top: ${spaceXXL};
`;

export const StyledBackButton = styled(StyledSubmitButton)`
  margin-right: ${spaceL};
`;

export const StyledLabel = styled(Label)`
  display: flex;
  gap: ${spaceM};
  justify-content: space-between;
  margin-top: ${spaceXXL};
`;

export const StyledInfo = styled(BodyCopy)`
  color: ${xdlColorTextSecondary};
  margin-top: ${spaceL};
`;

export const StyledHeadline = styled(Headline)`
  display: flex;
  align-items: center;
  gap: 0 ${spaceL};
  margin-bottom: ${spaceXXL};
`;

export const StyledTag = styled(Tag)`
  margin-top: ${spaceL};
`;

export const StyledIllustration = styled(IllustrationSpotJobPosition)`
  flex-shrink: 0;
`;

export const StyledHr = styled.hr`
  height: 1px;
  width: 100%;
  margin: ${spaceXXL} 0;
  border: 0 none;
  background-color: ${xdlColorBorderSoft};
`;

export const StyledTagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spaceL};
  flex-wrap: wrap;
`;
